/* P.N.E. V6.4 — Browse the full available inventory as expanding cards.
 * No code runs on product, cart, checkout, or other pages. */
(() => {
  const mounted = new WeakSet();
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  function boot(scope = document) {
    scope.querySelectorAll('[data-pne-shelf-expanded]').forEach(root => {
      if (mounted.has(root)) return;
      const rail = root.querySelector('[data-pne-shelf-rail]');
      const viewport = root.querySelector('[data-pne-shelf-viewport]');
      const cards = [...root.querySelectorAll('[data-pne-shelf-card]')];
      if (!rail || !viewport || !cards.length) return;
      mounted.add(root);
      const current = root.querySelector('[data-pne-shelf-current]');
      let active = 0;
      let dragging = false, dragStartX = 0, dragScrollLeft = 0, dragged = false;
      const mobile = () => matchMedia('(max-width: 989px)').matches;
      function reveal(i, scroll = false) {
        active = Math.max(0, Math.min(cards.length - 1, i));
        cards.forEach((card, index) => card.classList.toggle('is-active', index === active));
        if (current) current.textContent = String(active + 1).padStart(2, '0');
        if (scroll) {
          // Horizontal scroll only. Never scroll the entire document when a card expands.
          requestAnimationFrame(() => {
            const card = cards[active];
            const left = card.offsetLeft - rail.offsetLeft;
            const right = left + card.offsetWidth;
            const currentLeft = viewport.scrollLeft;
            const viewportWidth = viewport.clientWidth;
            let target = currentLeft;
            if (left < currentLeft + 8) target = Math.max(0, left - 8);
            else if (right > currentLeft + viewportWidth - 8) target = Math.max(0, right - viewportWidth + 8);
            viewport.scrollTo({ left: target, behavior: reduce() ? 'instant' : 'smooth' });
          });
        }
      }
      cards.forEach((card, i) => {
        card.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse' && !mobile() && !dragging) reveal(i);
        });
        card.addEventListener('focus', () => reveal(i, true));
        card.addEventListener('click', event => {
          if (dragged) { event.preventDefault(); event.stopPropagation(); return; }
          if (event.target.closest('button, .pne-expanded-card__purchase-actions')) return;
          if ((mobile() || event.pointerType === 'touch') && i !== active) {
            event.preventDefault(); reveal(i, true);
          }
        });
      });
      viewport.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true; dragged = false; dragStartX = event.clientX; dragScrollLeft = viewport.scrollLeft;
      });
      viewport.addEventListener('pointermove', event => {
        if (!dragging) return;
        const delta = event.clientX - dragStartX;
        if (Math.abs(delta) > 6) dragged = true;
        if (dragged) viewport.scrollLeft = dragScrollLeft - delta;
      });
      const endDrag = () => {
        if (!dragging) return;
        dragging = false;
        if (dragged) setTimeout(() => { dragged = false; }, 200);
      };
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('pointerleave', endDrag);
      root.querySelector('[data-pne-shelf-prev]')?.addEventListener('click', () => reveal(active - 1, true));
      root.querySelector('[data-pne-shelf-next]')?.addEventListener('click', () => reveal(active + 1, true));
      reveal(0);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), {once:true});
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
